import type { RepeatBindings } from './repeatBindings';

/**
 * Compares a repeat binding path like `opt.value` or `opt.label` to `eq`
 * using the current repeat scope.
 */
export function evaluateRepeatItemEq(
  binding: string,
  eq: string,
  scope: RepeatBindings
): boolean {
  const dot = binding.indexOf('.');
  if (dot <= 0) return false;
  const alias = binding.slice(0, dot);
  const key = binding.slice(dot + 1);
  const item = scope[alias];
  if (!item) return false;
  if (key === 'value') return item.value === eq;
  if (key === 'label') return item.label === eq;
  return false;
}
